import classNames from 'classnames';

import ErrorText from '../ErrorText';

import styles from './_index.module.scss';

export interface TextAreaProps extends Omit<
  React.TextareaHTMLAttributes<HTMLTextAreaElement>,
  'onChange'
> {
  error?: string;
  isDisabled?: boolean;
  label?: string;
  onChange: (value: string) => void;
}

const TextArea = ({
  'aria-label': ariaLabel = 'textarea',
  className,
  error,
  isDisabled,
  label,
  onChange,
  value,
  ...props
}: TextAreaProps) => {
  const textAreaClassNames = {
    [styles['is-error']]: error,
  };

  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    onChange(event.target.value);
  };

  return (
    <div>
      {label && <label className={styles['textarea-label']}>{label}</label>}
      <textarea
        aria-label={ariaLabel}
        className={classNames(styles['textarea'], className, textAreaClassNames)}
        disabled={isDisabled}
        onChange={handleChange}
        value={value}
        {...props}
      />
      {error && <ErrorText className={styles['textarea-error']}>{error}</ErrorText>}
    </div>
  );
};

export default TextArea;
